import React from 'react'
import { ScrollView } from 'react-native'

import { ITeamEarningsFiltersDTO } from '@zet/my-teams/src/api/teamEarnings/types'

import EarningsFilters from '.'

type Props = {
  filters: ITeamEarningsFiltersDTO
  setFilters: (x: ITeamEarningsFiltersDTO) => void
}

const TeamEarningsFilters = ({ filters, setFilters }: Props) => {
  function handleClearFilter() {
    setFilters({} as ITeamEarningsFiltersDTO)
  }
  return (
    <ScrollView
      showsHorizontalScrollIndicator={false}
      horizontal={true}
      className="bg-neutral-white100 my-2 flex-grow-0"
      keyboardDismissMode="on-drag"
      contentContainerStyle={{
        paddingRight: 8,
        right: 10,
        alignItems: 'center',
      }}
    >
      <EarningsFilters
        filters={filters}
        setFilters={setFilters}
        handleClearFilter={handleClearFilter}
      />
    </ScrollView>
  )
}

export default TeamEarningsFilters
